import { Alert } from '@libs/ui/ds'
import { withPlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'

const MultipleSalaryCompensatoryInfo = ({ t }) => (
  <Alert intent='semantic.blue'>
    {t('restForm.multipleSalaryCompensatoryInfo')}
  </Alert>
)

export default withPlanningFormTranslation()(MultipleSalaryCompensatoryInfo)
